<template>
  <div>
    <message-modal />
    <div>
      <main-header />
      <iframe
        class="precarriage-v2-iframe"
        :src="precarriageV2Url"
        title="Precarriage V2"
        frameborder="0" />
    </div>
  </div>
</template>

<script>
import config from '@/config'

export default {
  name: 'PreCarriageList',
  computed: {
    precarriageV2Url () {
      const base = (config.get_FRONTEND_V2_URL() || '').replace(/\/+$/, '')
      const token = this.$store.state.auth.token
      return `${base}/#/precarriage-window?token=${encodeURIComponent(token)}`
    }
  }
}
</script>
<style>
.precarriage-v2-iframe {
  width: 100%;
  height: calc(100vh - 60px);
  border: 0;
  display: block;
}
</style>
